import { render, staticRenderFns } from "./InspirationsMenu.vue?vue&type=template&id=3a80e32c&"
import script from "./InspirationsMenu.vue?vue&type=script&lang=js&"
export * from "./InspirationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./InspirationsMenu.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports